import styled from 'styled-components';
import { colorBlue, colorRed, colorWhite, mediaQueryMobileLargeMin, mediaQueryDesktopMin } from 'styleUtils';
import Icon from 'components/Icon';
var colorBlueGray = '#d2d9e0';
export var MenuWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1d8jes-0"
})(["border-top:1px solid ", ";border-bottom:1px solid ", ";@media ", "{padding:0 16px 8px;border:0;}[data-item-index='0']{padding-left:8px;}[data-item-index='last']{padding-right:8px;}@media ", "{[data-item-index='0']{padding-left:0;}[data-item-index='last']{padding-right:0;}}"], colorBlueGray, colorBlueGray, mediaQueryMobileLargeMin, mediaQueryMobileLargeMin);
export var LinksList = /*#__PURE__*/styled.ul.withConfig({
  componentId: "sc-1d8jes-1"
})(["display:inline-flex;flex-wrap:nowrap;padding:0 8px;@media ", "{padding:0;}"], mediaQueryDesktopMin);
export var Link = /*#__PURE__*/styled.a.withConfig({
  componentId: "sc-1d8jes-2"
})(["display:inline-flex;align-items:center;cursor:pointer;color:", ";font-size:14px;padding:0 16px 0 0;transition:color 0.2s ease;border:0;background:", ";white-space:nowrap;&::first-letter{text-transform:uppercase;}"], colorBlue, colorWhite);
var underline = "\n  &:before {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 8px;\n    right: 8px;\n    height: 2px;\n    z-index: 1;\n    background-color: ".concat(colorRed, ";\n  }\n\n  @media ").concat(mediaQueryMobileLargeMin, " {\n    &:before {\n      display: none;\n    } \n");
export var ListItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-1d8jes-3"
})(["position:relative;list-style-type:none;", " ", ""], function (_ref) {
  var active = _ref.active;

  if (active) {
    return "\n        ".concat(Link, " {\n          color: ").concat(colorRed, "\n        }\n\n        ").concat(underline, "\n      ");
  }

  return "";
}, function (_ref2) {
  var mobile = _ref2.mobile;

  if (mobile) {
    return "\n        &:hover {\n          ".concat(Link, " {\n            color: ").concat(colorRed, ";\n          }\n\n          ").concat(underline, "\n        }\n      ");
  }

  return "\n      &:hover {\n        ".concat(Link, " {\n          color: ").concat(colorRed, ";\n        }\n      }\n    ");
});
export var LinkIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-1d8jes-4"
})(["width:8px;margin-left:4px;transition:transform 0.3s ease;"]);
export var LinkOptionItem = /*#__PURE__*/styled.li.withConfig({
  componentId: "sc-1d8jes-5"
})(["list-style-type:none;border-bottom:1px solid #e3e3e3;padding:8px;&:last-child{border-bottom:0;}"]);
export var LinkOption = /*#__PURE__*/styled(Link).withConfig({
  componentId: "sc-1d8jes-6"
})(["padding:10px 16px;line-height:initial;&::first-letter{text-transform:uppercase;}", ""], function (_ref3) {
  var active = _ref3.active;

  if (active) {
    return "\n        color: ".concat(colorRed, "\n      ");
  }

  return "";
});